module.exports = __webpack_public_path__ + "static/img/share_emoji_06.21f39f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_emoji_06.png
// module id = S3yl
// module chunks = 1